import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { Typography, Card, CardActionArea, CardContent, Stack } from '@mui/material';

import { FormatHelper } from '../helpers';
import { DateTimeFormats, NotificationType, UserRoleIds } from '../constants';
import { OrderStatuses } from '../constants';

const Notification = props => {
  const { item } = props;
  const [translate] = useTranslation();

  const format = useCallback(
    (type, data) => {
      switch (type) {
        case NotificationType.Message.New:
          return translate('notification_NewMessageTemplate');
        case NotificationType.User.Locked:
          return translate('notification_UserLockedTemplate');
        case NotificationType.Order.Placed:
          return translate('notification_OrderPlacedTemplate').replace('#{userName}', data?.userName);
        case NotificationType.Order.Updated:
          return `${translate('notification_OrderUpdatedTemplate')}
          ${
            data?.orderStatus === OrderStatuses.Paid
              ? translate('orderPaidNotification').replace('#{orderNumber}', data?.orderNumber)
              : data?.orderStatus === OrderStatuses.Delivered
                ? translate('orderDeliveredNotification').replace('#{orderNumber}', data?.orderNumber)
                : ''
          }`;
        case NotificationType.Order.Cancelled:
          return `${translate('notification_OrderCancelledTemplate')}
           ${
             data?.performerUserType === UserRoleIds.Admin
               ? translate('orderCancelledByAdminNotification').replace('#{orderNumber}', data?.orderNumber)
               : translate('orderCancelledByUserNotification').replace('#{orderNumber}', data?.orderNumber)
           }`;
        case NotificationType.Invoice.Issued:
          return translate('notification_InvoiceIssuedTemplate');
        case NotificationType.Invoice.Paid:
          return translate('notification_InvoicePaidTemplate');
        case NotificationType.Invoice.Failed:
          return translate('notification_InvoiceFailedTemplate');
        case NotificationType.Quotation.Requested:
          return translate('notification_ProposalRequestedTemplate').replace('#{userName}', data?.userName);
        case NotificationType.Quotation.Updated:
          return translate('notification_ProposalUpdatedTemplate')
            .replace('#{quoteNumber}', data?.quoteNumber)
            .replace('#{userName}', data?.userName);
        case NotificationType.Quotation.Accepted:
          return translate('notification_ProposalAcceptedTemplate')
            .replace('#{quoteNumber}', data?.quoteNumber)
            .replace('#{userName}', data?.userName);
        case NotificationType.Cart.ItemUpdated:
          return translate('notification_CartItemUpdatedTemplate');
        default:
          return '';
      }
    },
    [translate],
  );

  const getLink = useCallback((type, data) => {
    switch (type) {
      case NotificationType.Message.New:
        return '/message';
      case NotificationType.User.Locked:
        return '';
      case NotificationType.Order.Placed:
        return `/orders/${data?.orderNumber}`;
      case NotificationType.Order.Updated:
        return `/orders/${data?.orderNumber}`;
      case NotificationType.Order.Cancelled:
        return `/orders/${data?.orderNumber}`;
      case NotificationType.Invoice.Issued:
        return `/invoice/${data?.invoiceNumber}`;
      case NotificationType.Invoice.Paid:
        return `/invoice/${data?.invoiceNumber}`;
      case NotificationType.Invoice.Failed:
        return `/invoice/${data?.invoiceNumber}`;
      case NotificationType.Quotation.Requested:
        return '/proposal-requests';
      case NotificationType.Quotation.Updated:
        return `/proposal-requests`;
      case NotificationType.Quotation.Accepted:
        return `/proposal-requests`;
      case NotificationType.Cart.ItemUpdated:
        return '';
      default:
        return '';
    }
  }, []);

  if (!item) return <></>;
  return (
    <Card variant='outlined' square={false} p={2}>
      <CardActionArea href={getLink(item?.type, item?.data)}>
        <CardContent>
          <Stack direction='column' spacing={2}>
            <Typography color={item?.isRead ? undefined : 'info.main'}>{format(item?.type, item?.data)}</Typography>
            <Typography variant='caption' color='GrayText'>
              {FormatHelper.formatDateTime(item?.createdAt, DateTimeFormats.Default)}
            </Typography>
          </Stack>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default Notification;
